import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProjectNameRenderer = ({ data }) => {
  if (!data || !data.project) {
    return null;
  }

  return (
    <>
      <Link to={`/crm/projects/${data.project.id}`} target="_blank">
        {data.project.name}
      </Link>

      <div className="tw-text-xs tw-my-0 tw-py-0">
        {data.building_description ? `${data.building_name}-${data.building_description}` : data.building_name}
      </div>

      {data.sts_notes && (
        <div className="tw-text-red-600 tw-text-[11px]">
          {data.sts_notes}
        </div>
      )}

      {data.qty_of_identical_bldgs > 1 && (
        <div className="tw-text-[11px] tw-my-0 tw-py-0">
          Identical Bldgs: <strong>{data.qty_of_identical_bldgs}</strong>
        </div>
      )}
    </>
  );
};

ProjectNameRenderer.propTypes = {
  data: PropTypes.object.isRequired
}

export default ProjectNameRenderer;
